import React, { useEffect, useMemo, useCallback } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import BottomNavigation from "../../../layout/fragments/bottom-navigation";
import SuccessReminder from "../components/success-reminder";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setSuccessReminder } from "../../../../store/actions/pages/customer";
import MeLoading from "../components/loading";
import LoginPage from "../../login2/components/alert-login";
import { useApp } from "../../../hooks/common";
import ScrollToTop from "../../../components/pageicons/back-top";
import { useLocation } from "react-router-dom";
import SizeChartWrapped from "../../../layout/fragments/size-chart2";
import Confirm from "../../../components/alters/confirm";
import Alert from "../../../components/alters/alert";
import { TOOGLE_UI_CONFIRM, TOOGLE_UI_ALERT } from "../../../../store/actions/ui";

export default props =>{
    useStyles(cls);
    const pageCustomer = useSelector(state =>state.pageCustomer);
    const { successReminder } = pageCustomer;
    const dispatch = useDispatch();
    const isApp = useApp()
    const location = useLocation()
    const ui = useSelector(state => state.ui)

    const shouldPaddingBottom = useMemo(() => {
        if(
            location?.pathname?.indexOf("/support/contact-us") != -1 ||
            location?.pathname?.indexOf("/faq/support-ticket") != -1
          ){
            return false
        } else {
            return true
        }
    }, [location])

    const closeConfirmHandle = useCallback(() => {
        dispatch({
            type: TOOGLE_UI_CONFIRM,
            payload: null
        })
    }, [])

    const closeAlertHandle = useCallback(() => {
        dispatch({
            type: TOOGLE_UI_ALERT,
            payload: null
        })
    }, [])

    return <div className={cls.UserLayout}>
        <div className={`${shouldPaddingBottom && cls.Content} ${!shouldPaddingBottom && cls.defaultHeight}`}>
            {props?.children}
        </div>

        {
            !isApp && <BottomNavigation />
        }

        <SuccessReminder 
            show={!!successReminder} 
            reminderData={successReminder} 
            onClose={() =>{
                dispatch(setSuccessReminder(null));
            }}
        />

        <MeLoading loading={pageCustomer?.loading} />

        <LoginPage />

        <ScrollToTop/>

        <SizeChartWrapped/>

        <Confirm show={ui.confirm?.show} options={ui.confirm?.options} onClose={closeConfirmHandle}/>
        
        <Alert show={ui.alert?.show} options={ui.alert?.options} onClose={closeAlertHandle}/>
    </div>
}